export default "__VITE_ASSET__DWJZo2IG__"